module.exports = __webpack_public_path__ + "static/img/1-2.b7da210.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/1-2.png
// module id = Ykqu
// module chunks = 0